import { defineComponent as _defineComponent } from 'vue'
import type Provider from '@/interfaces/provider';

import GlobalCards from '@/components/home/global/GlobalCards.vue';
import GlobalHero from '@/components/home/global/GlobalHero.vue';
import GlobalTitles from '@/components/home/global/GlobalTitles.vue';
import CountriesList from '@/components/countries-list/CountriesList.vue';
import GlobalLargeSpotlight from '@/components/home/global/GlobalLargeSpotlight.vue';
import GlobalSmallSpotlight from '@/components/home/global/GlobalSmallSpotlight.vue';
import GlobalProviderSpotlight from '@/components/home/global/GlobalProviderSpotlight.vue';
import CallToAction from '@/components/home/global/CallToAction.vue';

import { useLanguageStore } from '@/helpers/composables/useStores';

import { COUNTRY_EXCEPTIONS } from '@/constants/web-locales.constant';
import { ObjectType } from '@/@types/graphql-types';
import { isSportSupported } from '@/enums/sports';

import { computed } from 'vue';
import GlobalEditorialLists from '@/components/home/global/GlobalEditorialLists.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Global',
  props: {
    providersByShortName: null
  },
  setup(__props: any) {

const GlobalSports = () =>
	import(/* webpackChunkName: "spotlight-sport" */ '@/components/home/global/GlobalSports.vue');

// Hardcoded value for now @liam.best
const spotlightProvider = {
	name: 'atp',
	packageId: 350,
};

const logoSrc = `/${ASSETS_DIR}/img/home/logo.svg`;



const { activeLocalesList, country, language, webLocale } = useLanguageStore();

const showEditorialModule = computed(() =>
	['US', 'GB', 'IN', 'DE', 'FR', 'IT', 'ES', 'BR', 'TR'].includes(country.value)
);

const hasSports = computed(() => {
	const isException = COUNTRY_EXCEPTIONS[webLocale.value];
	if (isException) {
		return isSportSupported(isException);
	}

	return isSportSupported(webLocale.value);
});

return { __sfc: true,GlobalSports, spotlightProvider, logoSrc, activeLocalesList, country, language, webLocale, showEditorialModule, hasSports, GlobalCards, GlobalHero, GlobalTitles, CountriesList, GlobalLargeSpotlight, GlobalSmallSpotlight, GlobalProviderSpotlight, CallToAction, ObjectType, GlobalEditorialLists }
}

})